module.exports = __webpack_public_path__ + "media/images/icons/edit-4b45de42f9c06cd41479077f21a9a17c.svg";